import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthTokenResponse, ProvisioningResponse } from "../models/kiosk.model";
import {
  KioskLocalStorageKeysEnum,
  LocalStorageService,
} from "./local-storage.service";

@Injectable({
  providedIn: "root",
})
export class KioskSetupService {
  private readonly http = inject(HttpClient);
  private readonly localStorageService = inject(LocalStorageService);

  getSessionId(): Observable<{ shortId: string }> {
    return this.http.post<{ shortId: string }>(`/v1/kiosk/pairingSessions`, {});
  }

  getProvisioningSession(shortId: string): Observable<ProvisioningResponse> {
    return this.http.post<ProvisioningResponse>(
      `/v1/kiosk/pairingSessions/${shortId}/provision`,
      {},
    );
  }

  getAuthToken(): Observable<AuthTokenResponse> {
    const refreshToken = this.localStorageService.getItem(
      KioskLocalStorageKeysEnum.REFRESH_TOKEN,
    );

    if (!refreshToken) {
      throw new Error("No refresh token found");
    }
    return this.http.post<AuthTokenResponse>(`/v1/kiosk/auth/accessToken`, {});
  }
}
